enum ArmorialSheetType {
    armoiries = 'armes',
    iconographie = 'iconographie',
  }

export default ArmorialSheetType;